const notiToggle = (payload) => {
  return {
    type: "getnotification",
    payload,
  };
};

export default notiToggle;
